class SearchProductRequest {
  constructor(public readonly page: number,
              public readonly perPage: number,
              public readonly query: string,
              public readonly sortType: string) {
  }
}

export default SearchProductRequest;